import { createClient, configureChains, Chain } from 'wagmi';
import {
  avalanche,
  bsc,
  mainnet,
  bscTestnet,
  fantom,
  optimism,
  polygon,
} from 'wagmi/chains';
import { MetaMaskConnector } from 'wagmi/connectors/metaMask';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';
import { InjectedConnector } from 'wagmi/connectors/injected';
import { publicProvider } from 'wagmi/providers/public';
import { LedgerConnector } from 'wagmi/connectors/ledger';
import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet';
import { MultiverxConnector } from './../connectors/MultiverxConnector';
import { infuraProvider } from 'wagmi/providers/infura';
import { helpers } from '@kattana-io/common';

const elrondNativeCurency = {
  name: 'EGold',
  /** 2-6 characters long */
  symbol: 'EGLD',
  decimals: 18,
};

export const ELROND_CHAIN_ID = 999999;
export const elrondChain = {
  id: ELROND_CHAIN_ID,
  name: 'Chain ELROND',
  network: 'ELROND',
  nativeCurrency: elrondNativeCurency,
  rpcUrls: {
    default: {
      http: ['https://api.elrond.com/'],
    },
  },
  testnet: false,
} as Chain;

// @todo add infuraProvider({ apiKey: process.env.REACT_APP_INFURA_ID })
const { chains, provider, webSocketProvider } = configureChains(
  [
    mainnet,
    avalanche,
    bsc,
    bscTestnet,
    fantom,
    {
      ...optimism,
      rpcUrls: {
        ...optimism.rpcUrls,
        default: { http: ['https://rpc.ankr.com/optimism'] },
        public: { http: ['https://rpc.ankr.com/optimism'] },
      },
    },
    polygon,
    elrondChain,
  ],
  [publicProvider()]
);

export function getClient() {
  const client = createClient({
    autoConnect: true,
    provider,
    webSocketProvider,
    connectors: [
      new MetaMaskConnector({ chains }),
      new WalletConnectConnector({
        chains,
        options: {
          qrcode: true,
        },
      }),
      new LedgerConnector({ chains }),
      new InjectedConnector({
        chains,
        options: {
          name: 'Injected',
          shimDisconnect: true,
        },
      }),
      new CoinbaseWalletConnector({
        chains,
        options: {
          appName: 'app.kattana.io',
        },
      }),
      new MultiverxConnector([elrondChain]),
      // @todo finish UD connector (trouble with signer - no idea how to get him)
      // new UnstoppableDomainsConnector({
      //   options: {
      //     clientID: '5cf4e887-c7a0-4502-a633-353cfdedfc5e',
      //     redirectUri: 'https://dev.kattana.io',
      //     postLogoutRedirectUri: 'https://dev.kattana.io',
      //     scope: 'openid wallet',
      //   }
      // }),
    ],
  });

  return client;
}
